import { chain, indexOf, without } from "lodash";
import { useLocalstorageState } from "rooks";

interface Favorites {
  get: () => string[];
  add: (identifier: string) => void;
  delete: (identifier: string) => void;
  contains: (identifier: string) => boolean;
  toggle: (identifier: string) => void;
  import: (identifiers: string[]) => void;
}

export const useFavorites = (): Favorites => {
  const [persistedFavorites, setPersistedFavorites] = useLocalstorageState<
    string[]
  >("PersistedFavorites", []);

  const favorites: Favorites = {
    get: () => {
      return persistedFavorites;
    },
    add: (identifier) => {
      setPersistedFavorites(
        chain(persistedFavorites).push(identifier).uniq().value()
      );
    },
    delete: (identifier) => {
      if (!favorites.contains(identifier)) {
        return;
      }
      setPersistedFavorites(without(persistedFavorites, identifier));
    },
    contains: (identifier) => {
      return indexOf(persistedFavorites, identifier) >= 0;
    },
    toggle: (identifier) => {
      if (favorites.contains(identifier)) {
        favorites.delete(identifier);
      } else {
        favorites.add(identifier);
      }
    },
    import: (identifiers) => {
      setPersistedFavorites(identifiers);
    },
  };

  return favorites;
};
